export const AUTH_CONFIG = {
  domain: 'roclinecard.auth0.com',
  clientId: 'elNiky73plDS5WR6jQuDgfae06lX36T8',
  callbackUrl: 'https://realchrisp.com/callback', 
  returnToUrl: 'http://realchrisp.com/'
}

export default AUTH_CONFIG;